import { FURNITURE_CONFIG } from '~/components/ThreeDModel/furnitureConfig'

export interface SidePanelDimensionsInput {
  width: number
  height: number
  depth: number
  isNewCollection: boolean
  isSingleNarrowColumn: boolean
  isTwoSingleDoorsException: boolean
  isMirrored: boolean
}

export interface SidePanelDimensions {
  thickness: number
  left: { width: number; height: number }
  right: { width: number; height: number }
}

export function computeSidePanelDimensions(
  input: SidePanelDimensionsInput
): SidePanelDimensions {
  const { panelThickness } = FURNITURE_CONFIG
  const {
    height,
    depth,
    isNewCollection,
    isSingleNarrowColumn,
    isTwoSingleDoorsException,
    isMirrored,
  } = input

  const sideHeight = isNewCollection ? height : height - panelThickness
  const sideDepth = isNewCollection
    ? depth + panelThickness
    : depth - panelThickness

  const leftSideDepth =
    (isSingleNarrowColumn && isNewCollection) ||
    (isTwoSingleDoorsException && !isMirrored)
      ? sideDepth - 2 * panelThickness
      : sideDepth

  const rightSideDepth =
    isTwoSingleDoorsException && isMirrored
      ? sideDepth - 2 * panelThickness
      : sideDepth

  return {
    thickness: panelThickness,
    left: { width: leftSideDepth, height: sideHeight },
    right: { width: rightSideDepth, height: sideHeight },
  }
}
